import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import USER_MANAGEMENT_CONTROLLER from '../../controllers/userManagement';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import UserForm from './UserForm';
import { UserFormModeEnum, UserRoleEnum } from '../../utils/enums';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import BusySpinner from '../spinners/BusySpinner';

const PAGE_NAME = 'CREATE_USER_PAGE';
const log = new Logger(PAGE_NAME, LOG_LEVELS.DEBUG);
const UserBlankForm = { id: '', firstName: '', lastName: '', role: UserRoleEnum.PREPARER.value };

const AddUser = (props) => {

    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        return () => {
            log.clearAllDictionaryErrors();
        }
    }, []);

    const submitHandler = (user) => {
        setShowSpinner(true);
        props.onCreateUser(
            user,
            () => {
                setShowSpinner(false);
                props.history.push("/UserManagement");
            },
            (error) => {
                setShowSpinner(false);
                if (error.status === 409) {
                    log.setDictionaryMessage(ALL_MESSAGES.DUPLICATE_USER_ID);
                } else {
                    log.setDictionaryMessage(ALL_MESSAGES.USER_CREATE_ERROR);
                }
            }
        );
    };

    return (
        <div className="content-area">
            <BusySpinner busy={showSpinner} />
            <s-container>
                <h1><LanguageStringResolver string='CreateUser' /></h1>
                <ApplicationMessages
                    scopes={[PAGE_NAME]}
                    errorIds={[ALL_MESSAGES.DUPLICATE_USER_ID]}
                    messageType="applicationWarning"
                />
                <ApplicationMessages
                    scopes={[PAGE_NAME]}
                    errorIds={[ALL_MESSAGES.USER_CREATE_ERROR]}
                    messageType="applicationError"
                />
                <UserForm
                    mode={UserFormModeEnum.CREATE}
                    user={UserBlankForm}
                    submitHandler={submitHandler}
                />
            </s-container>
        </div>
    );
}

function mapDispatchersToProps(dispatch) {
    return {
        onCreateUser: (user, successCallback, failureCallback) => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doCreate(user, successCallback, failureCallback));
        }
    }
}

export default authorize({
    name: 'AddUser',
    resource: connect(null, mapDispatchersToProps)(AddUser)
}, AuthorizedResource, {
    showNotAuthorized: true
});
